
<template>
    <vxe-modal v-model="dialoglocaluploadFolder" title="添加本地资料" width="500px" height="300px" show-zoom resize transfer
        draggable>
        
        <!-- <v-select v-model="fileTags" :items="opfileTags" label="选择项目" item-text="label" item-value="value"></v-select> -->
        <input style="display:none" type="file" id="folderId" webkitdirectory @change="onFolderSelected" />

        <!-- <ZyJsonForms  ref="myzyJsonforms"></ZyJsonForms> -->
        <!-- <zyUpload :path="`md/cmdp专业版用户上传本地资料/${title}`" ref="myzyUpload" @finishUpload="finishUpload"></zyUpload> -->
        <div v-show="isuploading">正在第上传<span class="isuplading"> {{ curIndex+1 }}个</span>，总共需上传{{ totalFile }}个文件</div>
        <div class="tips">
            选择标签，可以提供更好、更准确的服务
        </div>
        <div>
            <v-radio-group v-model="fileTags" row>
                <v-radio v-for="item in opfileTags" :label="item.label" :value="item.value"></v-radio>
            </v-radio-group>
        </div>

        <v-btn block color="#66b1ff" :loading="isuploading" @click="confirmUpload">上传</v-btn>
    </vxe-modal>
</template>

<script>
import userDocApi from "@/assets/js/userDocApi";
export default {
    name: 'localuploadFolder',
    data() {
        return {
            dialoglocaluploadFolder: false,
            uploadInfo: false,
            opfileTags: [
                { label: "ABS项目", value: "ABS项目" },
                { label: "IPO项目", value: "IPO项目" },
            ],
            fileTags: "",
            transferList:[],
            totalFile:0,
            curIndex:0,
            isuploading:false,
            title:""
        }
    },
    methods: {
        init(title) {
            this.uploadInfo = false;
            this.fileTags = "";
            this.transferList=[];
            this.totalFile=0;
            this.curIndex=0;
            this.dialoglocaluploadFolder = true;
            let that = this;
            this.title = title;
            this.$nextTick(() => {
                $('#folderId').click();
            })
        },
        // 上传目录前
        onFolderSelected(o) {
            let files=o.target.files;
            let transferList=[]
            // files.map(function(d){
            //     let transferItem = {
            //         folderName:d.webkitRelativePath.split('/')[0].trim(),
            //         status: '0', // 准备上传
            //         file:d
            //     }

            // })
            this.totalFile=files.length;
            this.isuploading=true;
            this.uploadFolder(files,0)
            console.log(o);
        },
        uploadFolder(trans,i){
           
            if(i>trans.length -1){
                this.isuploading=false;
               // this.dialoglocaluploadFolder=false;
               this.$notify({ type: 'success', message: '上传完成' })
                return;
            }
            let _file = trans[i];
            let aa=_file.webkitRelativePath.split('/');
            let _folderName = aa.slice(0,aa.length-1).join('/');
            let _param = {}
            _param.content = _file;
            _param.name = _file.name;
            _param.label =_file.name;
            let path=`md/cmdp专业版用户上传本地资料/${this.title}/${_folderName}`
            let tranObj={
                folderName:_folderName,
                folderLen:aa.length-1,
                status: '0', // 准备上传

            }
            userDocApi.createFile(path, _param.name, _param, _r => {
                if (_r.code == 200) {
                    this.curIndex=i;
                    tranObj.status=1 // 上传成功
                    tranObj.path= `${path}/${_param.name}`,
                    tranObj.label=_file.name,
                    tranObj.fileName= _param.name,
                    tranObj.fileSize= _file.size,
                    tranObj.fid= _r.data.fid

                }else{
                    
                    tranObj.status=3 // 上传失败
                }
                this.transferList.push(tranObj);
                i++;
                this.uploadFolder(trans,i);
            })
        },
        confirmUpload(){
            this.$EventBus.$emit("updatelocalInfo",{fileList:this.transferList,type:'folders'})
            this.dialoglocaluploadFolder = false;
        }
    },

}
</script>
<style lang="less" scoped>
.isuplading{
    color:#1867c0;
}
</style>

